<button tabindex="101" (click)="onClick.emit()" [attr.aria-label]="text" id="sub-navbar-next"
        class="border-3 border-black bg-theme-green border rounded-full inline-flex items-center justify-center py-1.5 px-6 my-1 cursor-pointer w-full
  text-center text-3xl font-bold text-theme-black font-theme-source
  disabled:opacity-75" [disabled]="disabled">
  {{text}}
</button>

